import { useEffect } from 'react';
import { TITULO_ABA } from '@/app/tituloAba';

/** Mantem o titulo da aba do acesso da escola. */
export function SincronizarTituloAba() {
  useEffect(() => {
    document.title = TITULO_ABA;
  }, []);

  return null;
}
